export default __webpack_public_path__ + "static/media/shopify-light.c253c40b.svg";